export enum DTableHeaderBody {
  SIMPLE_HEADER_TYPE = 'SimpleHeaderType',
  FILTER_HEADER_TYPE = 'FilterHeaderType',
}
